{
  "nav": { "payroll": "Teacher payroll" },
  "settings": {
    "menuItem": "Teaching pay",
    "title": "Teaching pay — {{name}}",
    "description": "The amount the center pays the teacher. Not related to the tuition charged to students.",
    "rules": "Pay rules",
    "rulesHelper": "The row with the highest student threshold the class still meets wins. A class of 8 with rules at 1 and 6 pays the \"from 6\" row.",
    "ruleRole": "Role",
    "ruleMinStudents": "From N students",
    "ruleRate": "Pay",
    "roleChinh": "Lead",
    "roleTroGiang": "Assistant",
    "addRule": "Add rule",
    "removeRule": "Remove row",
    "ruleDuplicate": "A rule already exists for this role at {{minStudents}} students",
    "noRules": "No pay rules yet — payroll will show \"No pay configured\".",
    "unit": "Pay is calculated per",
    "perSession": "VND/session",
    "perHour": "VND/hour",
    "exampleHour": "{{minutes}}-minute session → pay {{amount}}",
    "exampleSession": "Per session → {{amount}}, regardless of session length",
    "baseSalary": "Fixed monthly salary (optional)",
    "baseSalaryHelper": "Added on top of per-session pay each month. Leave blank if paid per session only.",
    "save": "Save",
    "saved": "Teaching pay saved",
    "slotOverride": "Custom pay…",
    "slotOverrideHelper": "Leave blank to use this teacher's pay rules. Affects teacher pay only — unrelated to tuition."
  },
  "page": {
    "title": "Teacher payroll",
    "month": "Month",
    "export": "Export Excel",
    "exportDownloading": "Downloading...",
    "exportError": "Could not export the payroll file",
    "branchNote": "Filtered by branch — session pay at this location only. Base salary, adjustments and the finalized total live in the All branches view.",
    "warnBand": "{{count}} past session(s) not yet marked — not included in payroll",
    "empty": "No teacher has taught this month",
    "noRateTitle": "No teacher has a pay rate yet",
    "noRateBody": "Set pay rates under Members & permissions — payroll is calculated from sessions marked present.",
    "noRateCta": "Members & permissions",
    "loadError": "Couldn't load payroll — try again.",
    "loadErrorRetry": "Retry",
    "rateUnset": "— not set",
    "table": {
      "teacher": "Teacher",
      "payLink": "Pay",
      "sessions": "Sessions",
      "roleSplit": "{{main}} as lead · {{assistant}} as assistant",
      "hours": "Hours",
      "sessionPay": "Session pay",
      "base": "Base salary",
      "adjustments": "Adjustments",
      "total": "Total",
      "status": "Status"
    },
    "badges": {
      "finalized": "Finalized",
      "draft": "Draft",
      "noRate": "No pay set",
      "noRateRole": "No pay set ({{role}})"
    },
    "roles": { "CHINH": "Lead", "TRO_GIANG": "Assistant" },
    "expand": {
      "sessionsTitle": "Sessions this month",
      "noSessions": "No sessions taught this month",
      "session": {
        "date": "Date",
        "subject": "Subject",
        "slot": "Class",
        "role": "Role",
        "students": "Students",
        "minutes": "Minutes",
        "rate": "Pay",
        "amount": "Amount",
        "minutesShort": "{{count}}min",
        "studentsShort": "{{count}} students",
        "overrideDot": "Custom pay for this class",
        "overrideLegend": "Custom pay for this class",
        "noRate": "No pay configured"
      },
      "exportTeacher": "Export this teacher",
      "perSession": "/session",
      "perHour": "/hour",
      "noAdjustments": "No adjustments yet",
      "viewExpense": "View the expense in Bookkeeping",
      "expenseDeleted": "This period's expense was deleted from Bookkeeping — the finalized total is unchanged."
    },
    "card": {
      "sessions": "{{count}} sessions",
      "sessions_one": "{{count}} session",
      "hours": "{{hours}} hours",
      "rateLabel": "Pay",
      "sheetDescription": "Payroll detail for {{month}}"
    },
    "adjustment": {
      "addAdjustment": "Add adjustment",
      "label": "Label",
      "labelPlaceholder": "e.g. Bonus, late penalty...",
      "amount": "Amount (negative to deduct)",
      "amountZero": "Amount must not be zero",
      "note": "Note (optional)",
      "add": "Add",
      "remove": "Remove"
    },
    "confirm": {
      "finalizeTitle": "Finalize this pay period?",
      "finalizeBody": "Finalize this month's pay for {{name}} totaling {{total}}. An expense will be recorded in Bookkeeping.",
      "finalizeUnattended": "There are still unmarked sessions this month — finalizing pays without counting them.",
      "finalizeUpcoming": "This teacher still has {{count}} session(s) later this month — finalizing now means those sessions won't be counted in any period.",
      "finalizeCta": "Finalize",
      "reopenTitle": "Reopen this pay period?",
      "reopenBody": "Delete the recorded expense and reopen this period?",
      "reopenCta": "Reopen"
    },
    "toast": {
      "finalized": "Payroll finalized",
      "reopened": "Pay period reopened",
      "adjustmentAdded": "Adjustment added",
      "adjustmentRemoved": "Adjustment removed"
    },
    "lockedCta": "Upgrade",
    "upsellTitle": "Adjustments and finalize/reopen need Pro",
    "upsellBody": "You can still view and export payroll on every plan. Upgrade to Pro to add adjustments and finalize or reopen a pay period."
  }
}
